<div
    class="cipo--flex--row cipo--flex--column--tablet cipo--gap--lg cipo--height--full cipo--min-height--400"
    data-testid="module-config-designer-skeleton"
    role="status"
    [attr.aria-busy]="true"
    [attr.aria-label]="label() | translate">
    <div class="cipo--flex--1 cipo--flex--column cipo--gap--lg">
        <div class="cipo--flex--1 cipo--flex--column cipo--gap--xs cipo-bg--black-50 cipo--border-radius--xs p-a-sm">
            @for (row of gridRows; track $index) {
                <div class="cipo--flex--row cipo--flex--wrap cipo--gap--xs">
                    @for (item of row; track $index) {
                        <div
                            class="designer-skeleton__item cipo-outlined-field cipo--flex--row cipo--align--center cipo--gap--md"
                            [style.width.%]="item.width">
                            <ngx-skeleton-loader class="cipo--flex--none" appearance="circle" [theme]="theme.icon" />
                            <div class="cipo--flex--1 cipo--flex--column cipo--gap--xs">
                                <ngx-skeleton-loader [theme]="item.name" />
                                <ngx-skeleton-loader [theme]="item.detail" />
                            </div>
                        </div>
                    }
                </div>
            }
        </div>

        @if (preview()) {
            <div class="cipo--flex--none cipo--flex--column cipo--gap--xs">
                <ngx-skeleton-loader [theme]="theme.previewTitle" />
                <ngx-skeleton-loader [theme]="theme.preview" />
            </div>
        }
    </div>

    <div class="cipo--flex--column cipo--gap--md cipo--width--350 cipo--flex--100--tablet cipo--flex--none">
        <ngx-skeleton-loader [theme]="theme.fieldsTitle" />
        <ngx-skeleton-loader [theme]="theme.search" />
        @for (field of fieldRows; track $index) {
            <div class="cipo-outlined-field cipo--flex--row cipo--align--center cipo--gap--md">
                <ngx-skeleton-loader class="cipo--flex--none" appearance="circle" [theme]="theme.icon" />
                <div class="cipo--flex--1 cipo--flex--column cipo--gap--xs">
                    <ngx-skeleton-loader [theme]="field.name" />
                    <ngx-skeleton-loader [theme]="field.label" />
                    <ngx-skeleton-loader [theme]="field.badge" />
                </div>
                <div class="cipo--flex--none cipo--flex--row cipo--gap--md">
                    <ngx-skeleton-loader appearance="circle" [theme]="theme.action" />
                    <ngx-skeleton-loader appearance="circle" [theme]="theme.action" />
                </div>
            </div>
        }
    </div>
</div>
